import { PageFetchManagerType } from './pageFetchManager';
import { StrapiComponentMetaData } from './types';

export interface ComponentBuilderFetchDataInputs {
  fetchManager: PageFetchManagerType;
  pageKey: string;
  componentData: StrapiComponentMetaData;
}

// ONLY use this for type assertions, never access array fields with it.
// This is only meant as a type helper
const FieldNameSymbolType = 'fieldName' as const;

export abstract class ComponentBuilder {
  key: string = '';
  getFieldNameSymbol(
    inputs: StrapiComponentMetaData
  ): typeof FieldNameSymbolType {
    return inputs.field as typeof FieldNameSymbolType;
  }
  abstract fetchData(inputs: ComponentBuilderFetchDataInputs): Promise<unknown>;
  abstract render(
    inputs: Awaited<ReturnType<(typeof this)['fetchData']>>,
    component: StrapiComponentMetaData
  ): JSX.Element | null;
}
